
export class ClientQueryAddComment {
	comment: string;
	trusteeView: boolean;
}
